import { Button, Heading, P, Section, Wrapper } from 'components/base';
import PropTypes from 'prop-types';
import React from 'react';
import BgTopLeft from 'svgs/elements/cta-1.svg';
import BgTopRight from 'svgs/elements/cta-2.svg';
import { signUpUrl } from 'utils/config';
import { bgTL, bgTR, content, root } from './CTA.module.scss';

const CTA = ({ wrapper ,heading, subheading, btnText, customBtn, isCustomContent, Content }) => (
  <Section className={root} padding="L">
    <BgTopRight className={bgTR} />
    <BgTopLeft className={bgTL} />
    <Wrapper size={wrapper} className={content}>
      {isCustomContent ? (
        <Content />
      ) : (
        <div>
          {heading && <Heading size="M" bold={subheading ? true : false} Tag="h2" marginBottom={subheading ? 'Xxs' : 'S'}>
            {heading}
          </Heading>}
          { subheading && <P Tag="h3" marginBottom="S">
            {subheading}
          </P>}
          { customBtn ? <div>{<Button type="regular" text={btnText} href={customBtn.url} />}</div>
            : <Button type="regular" text={btnText} href={signUpUrl} />
          }
        </div>
      )}
    </Wrapper>
  </Section>
);
CTA.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  btnText: PropTypes.string,
  isCustomContent: PropTypes.bool,
  Content: PropTypes.func,
  wrapper: PropTypes.string,
  customBtn: PropTypes.string
};
CTA.defaultTypes = {
  isCustomContent: false,
  wrapper: "L",
  customBtn: null
};

export default CTA;
